<template>
  <div class="renewal-container">
    <img :src="logo" alt="Vertex Cyber Security Logo" class="logo">
    <div v-if="isLoading" class="spinner"></div>
    <!-- <h1 class="title" :class="{ 'error-message': isError }">{{ message }}</h1> -->
    <p class="subtitle">{{ subMessage }}</p>
  </div>
</template>

<script>
import vertexLogo from '@/assets/img/vertex_logo.png';

export default {
  name: 'RenewalPage',
  data() {
    return {
      logo: vertexLogo,
      isLoading: true,
      isError: false,
      message: 'Processing Your Request...', // Updated initial message
      subMessage: 'Please wait a moment.',
    };
  },
  async created() {
    const token = this.$route.query.token;
    const uniqueKey = this.$route.params.unique_key;
    const accessKey = this.$route.params.access_key;

    if (!token || !uniqueKey || !accessKey) {
      this.isLoading = false;
      this.isError = true;
      this.message = "Invalid Link";
      this.subMessage = "This renewal link is incomplete. Please check the URL and try again.";
      return;
    }

    try {
      const response = await this.$axios_internal.post(`/proposals/renew`, {
          unique_key: uniqueKey,
          access_key: accessKey,
          token: token // The backend expects 'token', not 'renewal_token'
      });
      const responseData = response.data;

      this.isLoading = false;

      // Check the alreadyProcessed flag from the API response
      if (responseData.alreadyProcessed) {
        this.message = "Loading Proposal...";
        this.subMessage = "Taking you to the proposal now...";
        window.location.href = `/form/client-proposals/${uniqueKey}/${accessKey}`;
        return;
      }

      // Check the isReIssue flag from the API response
      if (responseData.isReIssue) {
        // --- REISSUE (DUPLICATION) SCENARIO ---
        this.$toast.success("Your request has been received.");
        this.message = "Thank You!";
        this.subMessage = "Your request has been received. We will be in touch shortly.";

      } else {
        // --- RENEWAL (DATE EXTENSION) SCENARIO ---
        this.$toast.success("Proposal has been extended successfully!");
        this.message = "Success!";
        this.subMessage = "Redirecting you to the proposal now...";

        // Redirect back to the original client proposal page
        setTimeout(() => {
            window.location.href = `/form/client-proposals/${uniqueKey}/${accessKey}`;
        }, 2000); // Wait 2 seconds before redirecting
      }

    } catch (error) {
      this.isLoading = false;
      this.isError = true;
      this.message = error.response?.data?.message || "Request Failed";
      this.subMessage = "This link may be invalid or has already expired. Please contact proposals@vertexcybersecurity.com.au.";
    }
  },
};
</script>

<style scoped>
.renewal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  /* Add these lines for the background image */
  background-image: url("~@/assets/img/BG_Mountain.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'Segoe UI', sans-serif;
  text-align: center;
}

.logo {
  max-width: 250px;
  margin-bottom: 40px;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #00a0c1;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.5s linear infinite;
  margin-bottom: 30px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.title {
  font-size: 2rem;
  font-weight: 500;
  color: #343a40;
  margin-bottom: 10px;
}

/* 3. Add a new class to style the error message */
.title.error-message {
  color: #d9534f; /* A bootstrap 'danger' red */
}

.subtitle {
  font-size: 1.1rem;
  color: #6c757d;
}
</style>